import * as React from 'react';
import './toggle.scss';

interface Props {
  label?: string;
  toggled: boolean;
  onClick: Function;
}

const Toggle: React.FC<Props> = ({ label, toggled, onClick }) => {
  const callback = () => {
    onClick(!toggled);
  };

  return (
    <label className="toggle__label">
      <input type="checkbox" checked={toggled} onClick={callback} className="toggle__input" />
      <span className="toggle__span" />
      <strong>{label ? label : ''}</strong>
    </label>
  );
};
export default Toggle;
